export enum PrefixTestEnum {
	CARD = 'card_',
	SEE_DETAILS = 'ver_detalhes_',
}
